import axios from 'axios'
import type { PartnerOfferApplicationRow, PartnerOfferDefinition, PartnerOfferStatus } from '@numeo/types-main-mobile'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export interface PartnerOfferSummary {
    definition: PartnerOfferDefinition
    enabled: boolean
    counts: Record<PartnerOfferStatus, number>
}

export const partnerOffersApi = {
    list: async (): Promise<PartnerOfferSummary[]> => {
        const res = await axios.get<Envelope<{ offers: PartnerOfferSummary[] }>>('/gluon/partner-offers')
        return res.data.data.offers
    },

    setEnabled: async (key: string, enabled: boolean): Promise<boolean> => {
        const res = await axios.put<Envelope<{ key: string; enabled: boolean }>>(`/gluon/partner-offers/${encodeURIComponent(key)}/enabled`, { enabled })
        return res.data.data.enabled
    },

    /** Decide a row stuck at `pending` after an unknown outcome: the partner has it (`in_review`) or it does not (`failed`, so the user may send it again). */
    resolve: async (key: string, id: string, status: 'in_review' | 'failed'): Promise<void> => {
        await axios.put(`/gluon/partner-offers/${encodeURIComponent(key)}/applications/${encodeURIComponent(id)}/resolve`, { status })
    },

    applications: async (
        key: string,
        options: { status?: PartnerOfferStatus; before?: string; limit?: number } = {}
    ): Promise<PartnerOfferApplicationRow[]> => {
        const res = await axios.get<Envelope<{ items: PartnerOfferApplicationRow[] }>>(`/gluon/partner-offers/${encodeURIComponent(key)}/applications`, {
            params: options,
        })
        return res.data.data.items
    },
}
